import styled, { css } from 'styled-components';

export const Container = styled.div`
  ${({ theme }) => css`
    align-items: center;
    background-color: ${theme.v2.colors.neutral.highPure};
    display: flex;
    flex-direction: column;
    font-family: ${theme.v2.font.family.primary};
    min-height: calc(100vh - 80px);
    margin: 0 23px 16px 23px;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      margin: 0;
      padding: 23px;
    }
  `}
`;

export const PageTitle = styled.h2`
  ${({ theme }) => css`
    align-items: center;
    color: ${theme.v2.colors.brand.primaryExtraDark};
    display: flex;
    gap: 4px;
    font-size: ${theme.v2.font.sizes.sm};
    font-weight: ${theme.v2.font.weights.bold};
    margin-top: 80px;
    margin-bottom: 16px;
  `}
`;

export const BetaTag = styled.span`
  ${({ theme }) => css`
    align-items: center;
    background-color: ${theme.v2.colors.brand.primaryLowLight};
    border-radius: 4px;
    color: ${theme.v2.colors.brand.primaryExtraDark};
    display: flex;
    font-size: ${theme.v2.font.sizes.xxs};
    font-weight: ${theme.v2.font.weights.medium};
    height: 24px;
    justify-content: center;
    margin-left: 5px;
    padding: 0 8px;
  `}
`;

export const Title = styled.h3`
  ${({ theme }) => css`
    color: ${theme.v2.colors.brand.primaryExtraDark};
    font-size: 36px;
    font-weight: ${theme.v2.font.weights.medium};
    line-height: 130%;
    margin-bottom: 0;
    margin-top: 0;
    max-width: 735px;
    text-align: center;

    strong {
      font-weight: ${theme.v2.font.weights.bold};
      color: ${theme.v2.colors.brand.primaryMedium};
    }

    @media (max-width: ${theme.v2.breakpoints.md}) {
      font-size: ${theme.v2.font.sizes.md};
    }
  `}
`;

export const Price = styled.p`
  ${({ theme, free }) => css`
    color: ${free ? theme.v2.colors.neutral.lowDark : theme.v2.colors.neutral.highPure};
    font-size: ${free ? theme.v2.font.sizes.md : theme.v2.font.sizes.xxs};
    font-weight: ${free ? theme.v2.font.weights.bold : theme.v2.font.weights.medium};
    line-height: 130%;
    margin: ${free ? '15px 0 0 0' : '26px 0 0 0'};

    strong {
      font-weight: ${theme.v2.font.weights.bold};
      font-size: ${theme.v2.font.sizes.md};
    };

  `}
`;

export const YearlyPrice = styled.span`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.highPure};
    font-size: ${theme.v2.font.sizes.xxs};
    font-weight: ${theme.v2.font.weights.regular};
    margin-top: 5px;
  `}
`;

export const Description = styled.p`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowPure};
    font-size: ${theme.v2.font.sizes.xs};
    font-weight: ${theme.v2.font.weights.regular};
    line-height: 150%;
    margin-bottom: 24px;
    margin-top: 4px;
    max-width: 655px;
    text-align: center;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      font-size: ${theme.v2.font.sizes.xxs};
    }
  `}
`;

export const ChoosePlan = styled.h3`
  ${({ theme }) => css`
    color: ${theme.v2.colors.brand.primaryExtraDark};
    margin-bottom: 32px;
    text-align: center;
    font-size: ${theme.v2.font.sizes.md};
    font-weight: ${theme.v2.font.weights.medium};
    line-height: 130%;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      font-size: ${theme.v2.font.sizes.sm};
    }
  `}
`;

export const PlanCards = styled.div`
  align-items: baseline;
  display: flex;
  flex-wrap: wrap-reverse;
  gap: 22px;
  justify-content: center;
  margin-bottom: 50px;
  width: 100%;
`;

export const Card = styled.div`
  ${({ theme, free }) => css`
    align-items: flex-start;
    background: ${free ? theme.v2.colors.neutral.highPure : theme.v2.colors.brand.primaryExtraDark};
    border-radius: 16px;
    border: 1px solid ${theme.v2.colors.neutral.highMedium};
    display: flex;
    flex-direction: column;
    height: fit-content;
    padding: 32px;
    width: ${free ? '322px' : '382px'};

    @media (max-width: ${theme.v2.breakpoints.md}) {
      width: 380px;
    }
  `}
`;

export const CardTitle = styled.h4`
  ${({ theme, free }) => css`
    color: ${free ? theme.v2.colors.neutral.lowDark : theme.v2.colors.neutral.highPure};
    font-size: ${theme.v2.font.sizes.md};
    font-weight: ${theme.v2.font.weights.bold};
    line-height: 130%;
    margin: 0;
  `}
`;

export const CardDescription = styled.p`
  ${({ theme, free }) => css`
    color: ${free ? theme.v2.colors.neutral.lowDark : theme.v2.colors.neutral.highPure};
    font-size: ${theme.v2.font.sizes.xxs};
    font-weight: ${theme.v2.font.weights.regular};
    line-height: 150%;
    margin: 14px 0;
  `}
`;

export const PlanSpec = styled.p`
  ${({ theme, free }) => css`
    color: ${free ? theme.v2.colors.neutral.lowDark : theme.v2.colors.neutral.highPure};
    display: flex;
    gap: 8px;
    align-items: center;
    font-size: ${theme.v2.font.sizes.xxs};
    font-weight: ${theme.v2.font.weights.medium};
    line-height: normal;
    margin: 0;
    margin-top: 16px;
  `}
`;
